import React from 'react';

interface DropUpArrowProps {
  size?: string | number;
  fill?: string;
}

const DropUpArrow = ({ size = '12', fill = '#4F4C4D' }: DropUpArrowProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.825 6.84167L5 3.02501L1.175 6.84167L0 5.66666L5 0.666662L10 5.66666L8.825 6.84167Z"
        fill={fill}
      />
    </svg>
  );
};

export default DropUpArrow;
